import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PersonalTrainers from '@/pages/home/components/PersonalTrainers';

export default function CoachesPage() {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Personal Trainers & Coaches at HUB30 | Expert Coaching – Jbeil, Lebanon</title>
        <meta
          name="description"
          content="Meet HUB30's team of expert personal trainers in Jbeil — specialising in strength, CrossFit, calisthenics, plyometrics, weight loss, and rehabilitation. Get matched with your coach."
        />
        <meta
          name="keywords"
          content="personal trainer Jbeil, personal coach Lebanon, CrossFit coach Jbeil, strength trainer Byblos, gym coach Lebanon, fitness coach Jbeil"
        />
        <link rel="canonical" href="https://hub30gym.com/coaches" />
        <meta property="og:title" content="Personal Trainers at HUB30 | Expert Coaches – Jbeil, Lebanon" />
        <meta property="og:description" content="Expert personal trainers at HUB30 gym in Jbeil for strength, CrossFit, calisthenics, and rehabilitation coaching." />
        <meta property="og:url" content="https://hub30gym.com/coaches" />
      </Helmet>
      <Navbar />
      <div className="pt-20">
        <PersonalTrainers />
      </div>
      <Footer />
    </div>
  );
}
